import { Component, Input, ElementRef, Renderer2, ViewChild } from '@angular/core';

@Component({
    selector: 'lnk',
    templateUrl: './link.component.html',
    styleUrls: ['./link.component.less']
})

export class LinkComponent {

    @Input()
    colorCls: string = '#FF4713'; //o2Color

    @Input()
    hoverColorCls: string = '#f17b60'; //oHoverColor

    @Input()
    text: string = 'link';

    @ViewChild('ref')
    ref!: ElementRef;

    @Input()
    textCls: string = "linkTextCls";

    @Input()
    testId: string = "";


    constructor(private element: ElementRef, private renderer: Renderer2) {  }

    
    ngAfterViewInit(): void {

        this.renderer.setStyle(this.element.nativeElement, "width", this.ref.nativeElement.offsetWidth + 'px');
        this.renderer.setStyle(this.element.nativeElement, "height", this.ref.nativeElement.offsetHeight + 'px');
        
        this.renderer.addClass(this.element.nativeElement, this.colorCls);
        this.renderer.addClass(this.ref.nativeElement, this.colorCls);
    }

    mouseIn(): void {

        this.renderer.removeClass(this.ref.nativeElement, this.colorCls);
        this.renderer.addClass(this.ref.nativeElement, this.hoverColorCls);
        
    }

    mouseOut(): void {

        this.renderer.removeClass(this.ref.nativeElement, this.hoverColorCls);
        this.renderer.addClass(this.ref.nativeElement, this.colorCls);

    }

}